import { Skeleton } from '@/shared/components/ui/skeleton';
import { MapPin } from 'lucide-react';

const ChargePointMapSkeleton = () => {
  return (
    <div className="$tw-relative $tw-rounded-md $tw-bg-foreground/5 $tw-p-4">
      {/* Map area skeleton */}
      <Skeleton className="$tw-h-[500px] $tw-w-full $tw-rounded-md" />

      {/* Centered loading indicator */}
      <div className="$tw-absolute $tw-inset-0 $tw-flex $tw-flex-col $tw-items-center $tw-justify-center $tw-gap-3">
        <div className="$tw-relative">
          <MapPin
            aria-label="Loading map"
            role="img"
            className="$tw-size-12 $tw-text-muted-foreground/50"
          />
        </div>
        <span role="status" aria-live="polite" className="$tw-text-sm $tw-text-muted-foreground">
          Cargando mapa...
        </span>
      </div>

      {/* Legend skeleton */}
      <div className="$tw-absolute $tw-bottom-4 $tw-left-4 $tw-z-10 $tw-rounded-md $tw-bg-background/90 $tw-p-4 $tw-backdrop-blur-sm">
        <Skeleton className="$tw-mb-3 $tw-h-5 $tw-w-16" />

        <div className="$tw-flex $tw-items-start $tw-gap-4">
          {/* Marker icon skeleton */}
          <Skeleton className="$tw-h-16 $tw-w-10 $tw-rounded-md" />

          {/* Legend items */}
          <div className="$tw-flex $tw-flex-col $tw-gap-2">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="$tw-flex $tw-items-center $tw-gap-2">
                <Skeleton className="$tw-size-4 $tw-rounded-full" />
                <Skeleton className="$tw-h-4 $tw-w-36" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChargePointMapSkeleton;
